import { CheckCircle2 } from 'lucide-react';
import useRequestAccess from './useRequestAccess';
import { REQUEST_ACCESS_EMAIL } from './constants';

const mix = (token, pct) => `color-mix(in srgb, var(${token}) ${pct}%, transparent)`;
const FIELD = 'w-full rounded-xl border border-white/12 bg-white/[0.04] px-4 py-3 text-white placeholder:text-slate-500 outline-none transition-colors focus:border-[#E8A838]/60';

// "Request early access" lead-capture card (mailto handoff). UI only; logic in hook.
// Colors reference platform brand tokens (--brand-*).
export default function NrouteRequestAccess({ sectionRef }) {
  const { form, error, sent, update, submit } = useRequestAccess();

  return (
    <section
      id="request-access"
      ref={sectionRef}
      className="relative scroll-mt-20 py-20 md:py-28"
      style={{ backgroundColor: 'var(--brand-bg)' }}
    >
      <div className="mx-auto max-w-xl px-4">
        <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-white/[0.02] p-8 backdrop-blur-sm sm:p-10">
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-white">Request early access</h2>
            <p className="mt-3 text-slate-300">
              nroute is invitation-only during rollout. Tell us a little about you and we'll be in touch.
            </p>
          </div>

          {sent ? (
            <div
              className="mt-8 flex flex-col items-center gap-3 rounded-2xl border p-6 text-center"
              style={{ borderColor: mix('--brand-accent', 30), backgroundColor: mix('--brand-accent', 10) }}
            >
              <CheckCircle2 size={28} style={{ color: 'var(--brand-accent)' }} />
              <p className="text-white">
                Your email app should have opened with your request ready to send. If it didn't,
                email us at{' '}
                <a href={`mailto:${REQUEST_ACCESS_EMAIL}`} className="font-semibold underline" style={{ color: 'var(--brand-secondary)' }}>
                  {REQUEST_ACCESS_EMAIL}
                </a>
                .
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <input className={FIELD} type="text" placeholder="Your name" value={form.name} onChange={update('name')} aria-label="Your name" />
              <input className={FIELD} type="email" placeholder="Email address" value={form.email} onChange={update('email')} aria-label="Email address" />
              <input className={FIELD} type="text" placeholder="What do you want to study? (optional)" value={form.interest} onChange={update('interest')} aria-label="What do you want to study" />
              {error && <p className="text-sm text-rose-400">{error}</p>}
              <button
                type="submit"
                className="w-full rounded-xl py-4 text-base font-semibold shadow-lg transition-all hover:brightness-105 hover:shadow-[0_0_28px_rgba(232,168,56,0.35)]"
                style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-primary)' }}
              >
                Request access
              </button>
              <p className="text-center text-xs text-slate-500">
                We'll only use your details to contact you about nroute access.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
